import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
import localStorageAvailable from '../../utils/localStorageAvailable';

// ----------------------------------------------------------------------
const base_url = '/v1/applicantstages';

const initialState = {
  isLoading: false,
  error: null,
  applicantstages: [],
  applicantstage: null,
};

const slice = createSlice({
  name: 'pipeline',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET ALL
    getAppStages(state, action) {
      state.isLoading = false;
      state.applicantstages = action.payload;
    },

    // GET ONE
    getAppStage(state, action) {
      state.isLoading = false;
      state.applicantstage = action.payload;
    },

    // CREATE
    createAppStage(state, action) {
      const newdata = action.payload;
      state.isLoading = false;
      state.applicantstages = [...state.applicantstages, newdata];
    },

    // UPDATE
    updateAppStage(state, action) {
      state.isLoading = false;
    },
  },
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function get() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const storageAvailable = localStorageAvailable();
      const username = storageAvailable ? localStorage.getItem('applicant_id') : '';            
      const response = await axios.get(`${base_url}/readbyapplicantid?applicantid=${username}`);
      dispatch(slice.actions.getAppStages(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getById(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`${base_url}/${id}/applicantstage`);
      dispatch(slice.actions.getAppStage(response.data.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getHistoryById(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`${base_url}/${id}/history`);
      dispatch(slice.actions.getAppStages(response.data.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function create(newData) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`${base_url}`, newData);
      dispatch(slice.actions.createAppStage(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

// ----------------------------------------------------------------------

export function update(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.put(`${base_url}`, data);
      dispatch(slice.actions.updateAppStage(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function deleteById(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`${base_url}?id=${id}`);
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
